import { AnalyticsAdType } from "./analytics_types.js";

let banner_ad_id: string | null = null;
let interstitial_ad_id: string | null = null;
let rewarded_ad_id: string | null = null;

let preload_banner_ad_id: string | null = null;
let preload_interstitial_ad_id: string | null = null;
let preload_rewarded_ad_id: string | null = null;

export function generateRandomId(): string
{
  const CHARS = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";

  for ( let i = 0; i < 4; i++ )
  {
    // одне 32-бітне число
    let rand = Math.floor( Math.random() * 0xFFFFFFFF );

    // дістаємо 4 символи з одного числа
    for ( let j = 0; j < 4; j++ )
    {
      let index = rand % CHARS.length;
      result += CHARS[ index ];
      rand = Math.floor( rand / CHARS.length );
    }
  }

  return result;
}

export const generateAdId = ( generate_ad_type: AnalyticsAdType ): string =>
{
  const id = generateRandomId();
  switch ( generate_ad_type ) {
    case AnalyticsAdType.BANNER:
      banner_ad_id = id;
      break;
    case AnalyticsAdType.INTERSTITIAL:
      interstitial_ad_id = id;
      break;
    case AnalyticsAdType.REWARDED:
      rewarded_ad_id = id;
      break;
  }
  return id;
}

export const generatePreloadAdId = ( generate_ad_type: AnalyticsAdType ): string =>
{
  const id = generateRandomId();
  switch ( generate_ad_type ) {
    case AnalyticsAdType.BANNER:
      preload_banner_ad_id = id;
      break;
    case AnalyticsAdType.INTERSTITIAL:
      preload_interstitial_ad_id = id;
      break;
    case AnalyticsAdType.REWARDED:
      preload_rewarded_ad_id = id;
      break;
  }
  return id;
}


export const getAdId = ( ad_type: AnalyticsAdType ): string | null =>
{
  switch ( ad_type ) {
    case AnalyticsAdType.BANNER:
      return banner_ad_id;
    case AnalyticsAdType.INTERSTITIAL:
      return interstitial_ad_id;
    case AnalyticsAdType.REWARDED:
      return rewarded_ad_id;
    default:
      return null;
  }
}


export const clearAdId = ( ad_type: AnalyticsAdType ): void =>
{
  switch ( ad_type ) {
    case AnalyticsAdType.BANNER:
      banner_ad_id = null;
      break;
    case AnalyticsAdType.INTERSTITIAL:
      interstitial_ad_id = null;
      break;
    case AnalyticsAdType.REWARDED:
      rewarded_ad_id = null;
      break;
  }
}

export const AdIdSwitcher = ( ad_type: AnalyticsAdType ): void =>
{
  switch( ad_type ) {
    case AnalyticsAdType.BANNER:
      banner_ad_id = preload_banner_ad_id;
      preload_banner_ad_id = null;
      break;
    case AnalyticsAdType.INTERSTITIAL:
      interstitial_ad_id = preload_interstitial_ad_id;
      preload_interstitial_ad_id = null;
      break;
    case AnalyticsAdType.REWARDED:
      rewarded_ad_id = preload_rewarded_ad_id;
      preload_rewarded_ad_id = null;
      break;
  }
}